import { signInWithRedirect, signOut as amplifySignOut, getCurrentUser as amplifyGetCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

export async function signIn(provider) {
  try {
    await signInWithRedirect({
      provider: provider || 'Google',
    });
  } catch (err) {
    console.error('Sign in error:', err);
    throw err;
  }
}

export async function signOut() {
  try {
    await amplifySignOut();
  } catch (err) {
    console.error('Sign out error:', err);
    throw err;
  }
}

export async function getCurrentUser() {
  try {
    const user = await amplifyGetCurrentUser();
    return user;
  } catch {
    return null;
  }
}

export async function getAuthToken() {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || null;
  } catch {
    return null;
  }
}

export function onAuthStateChange(callback) {
  const unsubscribe = Hub.listen('auth', ({ payload }) => {
    switch (payload.event) {
      case 'signedIn':
        callback({ event: 'signedIn', data: payload.data });
        break;
      case 'signedOut':
        callback({ event: 'signedOut' });
        break;
      case 'tokenRefresh':
        callback({ event: 'tokenRefresh' });
        break;
      default:
        break;
    }
  });
  return unsubscribe;
}
